// extracted by mini-css-extract-plugin
module.exports = {"root":"FormPerspectiveDirector_root"};